import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseurl, imgurl } from "../../baseurl";

function AllCategory() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${baseurl}getCategoriesWithSubcategories`);
        if (res.data?.categories) {
          setCategories(res.data.categories);
        }
      } catch (err) {
        console.error("Error fetching categories:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const visibleCategories = categories.slice(0, 30);

  return (
    <>
      {/* Container restricted to mobile view using Bootstrap 'd-block d-lg-none' */}
      <div className="mobile-category-section d-block d-lg-none py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3 px-1">
            <h6 className="fw-bold mb-0" style={{ color: "#222", fontSize: "1.1rem" }}>
              Shop by Category
            </h6>
            <Link to="/all-categories" className="text-decoration-none text-danger small fw-bold">
              View All
            </Link>
          </div>

          <div className="row g-3">
            {loading
              ? [...Array(8)].map((_, i) => (
                  <div key={i} className="col-3 text-center">
                    <div className="skeleton-circle mx-auto"></div>
                    <div className="skeleton-text mx-auto mt-2"></div>
                  </div>
                ))
              : (
                <>
                  {visibleCategories.map((cat) => (
                    <div className="col-4 text-center" key={cat.id}>
                      <Link to={`/category/${cat.slug}`} className="category-item text-decoration-none">
                        <div className="category-icon-wrapper">
                          <img
                            src={`${imgurl}${cat.image}`}
                            alt={cat.name}
                            className="category-img-mobile"
                          />
                        </div>
                        <span className="category-label">{cat.name}</span>
                      </Link>
                    </div>
                  ))}

                  {/* Redesigned "More" Button */}
                  {/* <div className="col-3 text-center">
                    <Link to="/all-categories" className="category-item text-decoration-none">
                      <div className="category-icon-wrapper more-gradient">
                        <i className="bi bi-grid-fill text-white" style={{ fontSize: "1.5rem" }}></i>
                        <span className="more-plus-icon">+</span>
                      </div>
                      <span className="category-label">More</span>
                    </Link>
                  </div> */}
                </>
              )}
          </div>
        </div>
      </div>

      <style>{`
        /* Hide entire component on screens wider than 992px */
        @media (min-width: 992px) {
          .mobile-category-section {
            display: none !important;
          }
        }

        .category-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
        }

        .category-icon-wrapper {
          width: 65px;
          height: 65px;
          background: #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          overflow: hidden;
          border: 1px solid #f0f0f0;
          transition: transform 0.2s ease;
        }

        .category-icon-wrapper:active {
          transform: scale(0.9);
        }

        .category-img-mobile {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .category-label {
          font-size: 11px;
          font-weight: 600;
          color: #444;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-transform: capitalize;
        }

        /* More Button Styling */
        .more-gradient {
          background: linear-gradient(135deg, #ff6b6b, #ff4757) !important;
          border: none !important;
          position: relative;
        }

        .more-plus-icon {
          color: white;
          font-size: 24px;
          font-weight: bold;
        }

        /* Skeletons */
        .skeleton-circle {
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: #eee;
          background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
          background-size: 200% 100%;
          animation: shine 1.5s linear infinite;
        }

        .skeleton-text {
          width: 40px;
          height: 8px;
          background: #eee;
          border-radius: 4px;
        }

        @keyframes shine {
          to { background-position-x: -200%; }
        }

        /* Optimized for very small phones */
        @media (max-width: 360px) {
          .category-icon-wrapper {
            width: 55px;
            height: 55px;
          }
          .category-label {
            font-size: 10px;
          }
        }
      `}</style>
    </>
  );
}

export default AllCategory;